import * as React from 'react'
import { SideDrawerForm } from '@sales-center/components'
import { GridColumnsSelectorProps } from './typings'
import { gridSelectorStyles as useStyles } from './styles'
import { useActions } from './useActions'
import SelectionPanel from './SelectionPanel'
import SortPanel from './SortPanel'

export const GridColumnsSelector: React.FC<GridColumnsSelectorProps> = (
  props,
) => {
  const { onCancel, hideDefaultBtn = false, apiRef } = props
  const { form } = useStyles
  const { state, dispatch, onSave } = useActions(props)

  return (
    <SideDrawerForm onSave={onSave} onCancel={onCancel} containerStyle={form}>
      <SelectionPanel
        state={state}
        dispatch={dispatch}
        hideDefaultBtn={hideDefaultBtn}
      />
      <SortPanel apiRef={apiRef} state={state} dispatch={dispatch} />
    </SideDrawerForm>
  )
}
